import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/accounts/$projectId/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      params,
      to: "/billing/accounts/$projectId/overview",
    });
  },
  component: () => null,
});
